import { render, staticRenderFns } from "./FormPassword.vue?vue&type=template&id=16cf9117&scoped=true&"
import script from "./FormPassword.vue?vue&type=script&lang=ts&"
export * from "./FormPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf9117",
  null
  
)

export default component.exports